import React, { useEffect } from "react"
import { Form2, Fields } from "@cd2/forms"
import { SubmitButton } from "../interfaceParts/SubmitButton"

interface IProps {
  onSubmit(data: { password: string; passwordConfirmation: string }): Promise<void>
  submitText?: string
}
export function ResetPasswordForm({ onSubmit, submitText }: IProps) {
  const handleSubmit = (data: { password: string; passwordConfirmation: string }) =>
    onSubmit({
      password: data.password.trim(),
      passwordConfirmation: data.passwordConfirmation.trim(),
    })
  return (
    <Form2.Form onSubmit={handleSubmit}>
      <Form2.Password
        field="password"
        validations={{ presence: true, minLength: 8 }}
        inputProps={{ autoComplete: "new-password" }}
      />
      <MatchesPasswordField />
      <SubmitButton value={submitText ?? "Reset password"} />
    </Form2.Form>
  )
}

export function MatchesPasswordField() {
  const passwordField = Form2.useField("password", { subscribe: true })
  const passwordConfirmationField = Form2.useField<string>("passwordConfirmation", {
    subscribe: true,
    defaultValue: "",
  })

  Form2.useFormSubmitLock(() => {
    if (passwordConfirmationField.getValue().trim() === "") {
      passwordConfirmationField.setError("must be present")
      return false
    } else if (passwordConfirmationField.getValue() !== passwordField.getValue()) {
      passwordConfirmationField.setError("must match password")
      return false
    } else {
      passwordConfirmationField.setError(undefined)
    }
  })

  useEffect(() => {
    if (
      passwordConfirmationField.getError() === "must match password" &&
      passwordConfirmationField.getValue() === passwordField.getValue()
    ) {
      passwordConfirmationField.setError(undefined)
    }
  }, [passwordConfirmationField.getValue(), passwordField.getValue()])

  return (
    <Fields.Password
      error={passwordConfirmationField.getError()}
      label="Confirm password*"
      value={passwordConfirmationField.getValue()}
      onChange={val => passwordConfirmationField.setValue(val)}
      inputProps={{ autoComplete: "new-password" }}
      includeVisibleToggle
    />
  )
}
